var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-tag',{attrs:{"size":_vm.size,"icon":_vm.icon,"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"reason"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }